import React from "react";
import { NavLink } from "react-router-dom";
import i18n from "../../../../i18n/i18n";
import Button from "../button/button";

interface FormProps {
    class?: string;
    renderError?: JSX.Element | null;
    renderContent: JSX.Element;
    backAddress: string | {pathname: string, state: string};
    isSubmitButtonBlocked: boolean;
    submit: () => void;
    saveButtonText?: string;
    hideCancelButton?: boolean;
}

export default class Form extends React.Component <FormProps> {
    render() {
        return (
            <>
                <div className={(this.props.class || "" ) + " form"}>
                    {this.props.renderError || null}
                    {this.props.renderContent}
                </div>
                <div className="buttons-wrapper">
                    <div className="buttons">
                        {!this.props.hideCancelButton && (
                            <NavLink to={this.props.backAddress} data-testid="cancel">
                                <Button text={i18n.t("cancel")} type="secondary"/>
                            </NavLink>
                        )}
                        <Button
                            text={this.props.saveButtonText? this.props.saveButtonText : i18n.t("save")}
                            type="primary"
                            testId="save"
                            onClick={this.props.submit}
                            isWaiting={this.props.isSubmitButtonBlocked}
                        />
                    </div>
                </div>
            </>
        );
    }
}